export default __webpack_public_path__ + "static/media/header-back.60813cf4.jpg";